import React from 'react';
import { Link } from 'gatsby';
import { StaticImage } from 'gatsby-plugin-image';
import { Box } from '@mui/material';

import styled from 'styled-components';

const HeaderContainer = styled.div`
  & header {
    text-align: left;

    & h1 {
      font-weight: normal;
    }

    & a {
      color: inherit;
      text-decoration: none;
    }
  }
`;

const Header = ({}) => (
  <HeaderContainer>
    <header className="flex">
      <Link to="/">
        <Box className="f-static" my={8}>
          <StaticImage
            src="../images/DobreDary_Logo.svg"
            alt="Dobredary"
            placeholder="tracedSVG"
            height={40}
          />
        </Box>
      </Link>
    </header>
  </HeaderContainer>
);

export default Header;
